<template>
  <div>
    <MainForm
      :name="FORM_NAMES.rejected"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      :ui-form="uiForm"
      ui-title="Striver card application"
    ></MainForm>
  </div>
</template>

<script>
// Models
var flag = true;
let newProduct = "";
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";

// Utils
import * as conditions from "@/forms/conditions";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";

import FieldsetAppointmentDate from "@/forms/components/shared/fieldsets/appointment-date";

export default {
  name: "Rejected",

  mixins: [FormComponentMixin],

  components: {
    // Components
    MainForm,
    StepModel,
    FieldsetAppointmentDate
  },

  methods: {
    ...conditions
  },

  mounted() {
    let product = this.$store.state.productType;

    if (product === "Personal_Loan") {
      newProduct = "Personal Loan";
    } else if (product === "Credit Card") {
      newProduct = "Credit Card";
    }
    let status;
    if (this.$store.state.appianIncomeInfo) {
      status = this.$store.state.appianIncomeInfo;
    } else {
      status = this.$store.state.creditScoreCalculationSatus;
    }
    let cifNumber = this.$store.state.cifnumber;
    let message;
    let title;
    if (this.$store.state.employeeCodes) {
      title = `REJECTED! Dear ${this.userName},`;
      message = `Thank you for your application. Based on the information provided by you, it looks like the Deem
          Auto Loan is not the best fit for you. Your customer identification number is ${cifNumber}.`;
    } else {
      title = `Rejected! Dear ${this.userName},`;
      message = `Thank you for your application. Based on the information provided by you, it looks like the Deem
              Auto Loan is not the best fit for you.`;
    }
    finishCallback: {
      this.showEndPage({
        title: title,
        subtitle: message,

        actionNameEndForm: "Back To Home"
      });
    }
  }
};
</script>
